import React from 'react'
import ColumnType from './Column.interface'
import Skeleton from '../Skeleton/Skeleton'
import useStyles from '../Table/useStyles'

interface PropsInterface {
    className?: string
    columns: ColumnType[];
    data: Record<string, unknown>[];
    loading?: boolean
    scrollAfterRow?: number
    'data-testid'?: string;
}

/**
 *
 */
const TableBody = ({
    className,
    data,
    columns,
    loading = false,
    scrollAfterRow,
    'data-testid': dataTestId = 'table-body'
}: PropsInterface): JSX.Element => {
    const styles = useStyles({ color: 'neutral-50' })
    const bodyData: Record<string, unknown>[] = loading
        ? Array.from({ length: scrollAfterRow || 1 }, () => ({}))
        : data
    return (
        <tbody className={className || styles.tBody} data-testid={dataTestId}>
            {bodyData.map((item, i) => {
                return (
                    <tr key={`table-row-${i}`} data-testid={`${dataTestId}-row-${i}`}>
                        {columns.map(({ accessor }, j) => {
                            return <td key={accessor} data-testid={`${dataTestId}-row-${i}-data-${j}`}>
                                {loading
                                    ? <Skeleton variant='rect' height={22} />
                                    : (item[accessor] ? item[accessor] : <>&mdash;</>)}
                            </td>
                        })}
                    </tr>
                )
            })}
        </tbody>
    )
}

export default TableBody
